import React, { useContext } from "react";
import ContentContext from "../../../common/context/ContentContext";
import { H3 } from "../../../common/components/Texts";
import { Container, Flex, Link, List, ListItem } from "@chakra-ui/react";
import { REACT_APP_API_URL } from "../../../api/base";
import { ContentAttachment } from "../../../common/types";

export default function ({contentId, attachments}: {contentId: string, attachments: ContentAttachment[]}) {

    // const playAudio = (id: string) => {
    //     const audio = document.querySelector(`[data-audio="${id}"]`);
    //     if (!audio) {
    //         console.error("Cannot find audio player with id", id);
    //         return;
    //     }
    //     // @ts-ignore
    //     audio.play();
    // };

    return <Container p={0} maxW="100%" mb="1rem">
        {attachments.length === 0 && "Sin archivos adjuntos"}
        {attachments.length > 0 &&
            <List>
                {attachments.map(a => <ListItem key={a._id}>
                    <Flex gap={"2"}>
                        <Link href={`${REACT_APP_API_URL}/content/${contentId}/attachment/${a._id}`} variant="underline" color="blue"> {a.originalFilename}</Link>
                        {a.mimetype.startsWith("audio/") &&
                            <audio data-audio={a._id} src={`${REACT_APP_API_URL}/content/${contentId}/attachment/${a._id}`} crossOrigin="use-credentials" controls />
                        }
                    </Flex>
                </ListItem>)}
            </List>
        }
    </Container>;
}